// Import this file from your pages 🌹
import { setStylesTarget } from 'typestyle';
if (typeof document != 'undefined')
  setStylesTarget(document.getElementById('styles-target')!);
